///<reference path="../../App/plugins/DefinitelyTyped/select2.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/alasql.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/xlsx.d.ts"/>
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {NgModule, Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';


declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function ExportToExcelNew(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function ExportMultiSheetExcel(item: any[], Name: any[], workSheetName: any, keys: any, Columns?: any): void;
declare function tablesToExcel(tables: any[], wsnames: any[], wbname: any, appname: any): void;
@Component({
    templateUrl: './AppViews/UserMoodReport/userMoodReport.html'
})

export class UserMoodReportComponent implements OnInit {
    userMoodItems: any = [];
    attendanceSummary: any[];
    teamItems: any[];
    siteUserItems: any = [];
    userDetail: any;
    selfuser: boolean = true;
    filter: any = {};
    attendanceUser: any = "";
    objSiteUserItem: any = [];
    userStatus: any = [];
    arr: any = [];
    arr2: any = [];
    recordItem: any = [];
    public showLoader = false;
    constant: Constants;
    siteItems:any;
options:any={};


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter = { 'TeamId': '', IsActive: true, 'UserId': this.userDetail.SiteUserId, 'MonthYear': moment().format('YYYY'), 'LoggedUserId': this.userDetail.SiteUserId , 'SiteId':""};
        this.constant = new Constants();


    }

    ngOnInit() {
        this.userStatus = this.constant.enumSiteUserStatus;
        this.filter.UserId = this.userDetail.SiteUserId;
        this.BindFilters();
        this.getSite();
    }


    ExportItems() {

        var UserId = 0
        if (this.filter.UserId == "") {
            UserId = 0;
        }
        else {
            UserId = this.filter.UserId;
        }
        var TeamId = 0
        if (this.filter.TeamId == "") {
            TeamId = this.userDetail.TeamID;
        }
        else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        
                
                this.showLoader = true;

                this._httpService.ajaxPost("Attendance/GetUserMoodReport", { "AttendanceId": 0, "UserId": UserId, "IsActive": this.filter.IsActive, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
                    data => {
                        this.recordItem = [];
                        this.userMoodItems = data["UserMood"];
                        this.userMoodItems.forEach(element => {
                            let objitem = {
                                Month: "", Happy: "", Ok: "", Sad: "", None: ""
                            };
                            
                            if (element.Month == null && element.Month == undefined) {
                                objitem.Month = "";
                            }
                            else {
                                objitem.Month = element.Month;
                            }

                            if (element.Happy == null && element.Happy ==undefined) {
                                objitem.Happy = "";
                            }
                            else {
                                objitem.Happy = element.Happy+"%";
                            }

                            if (element.Ok == null && element.Ok ==undefined) {
                                objitem.Ok = "";
                            }
                            else {
                                objitem.Ok = element.Ok+"%"
                            }

                            if (element.Sad == null && element.Sad == undefined) {
                                objitem.Sad = "";
                            }
                            else {
                                objitem.Sad = element.Sad+"%";
                            }


                            if (element.None == null && element.None == undefined ) {
                                objitem.None = "";
                            }
                            else {
                                if(objitem.Month=="Average")
                                objitem.None = "";
                                else
                                objitem.None = element.None+"%";
                            }

                            this.recordItem.push(objitem);
                        }
                        
                        );
                        var userMoodItems = this.recordItem;
                        //var attendanceSummary = this.attendanceSummary;
                        var opts = [{ sheetid: 'userMoodItems', header: true }];
                        var res = alasql('SELECT  INTO XLSX("UserMoodReport.xlsx",?) FROM ?', [opts, [userMoodItems]]);
                        this.showLoader = false;

                    },
                    err => {
                        console.log("GetAttendanceReport Failed");
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constant.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
        
    }

  public getSite() {
        this._httpService.ajaxPost('Common/GetSite', null).subscribe(
            data => {
                this.siteItems = data["Site"];
            }
        );
    }

    GetUsers(IsActive: boolean) {
        this.showLoader = true;
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }
        this._httpService.ajaxPost('Users/GetUsers', {
            "IsActive": IsActive,
            "Team": this.userDetail.TeamID,
            "UserId": userId
        }).subscribe(
            data => {
                this.siteUserItems = data["Users"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

    GetUserMood(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0; UserId = this.filter.UserId == "" ? 0 : this.filter.UserId;
        var TeamId = this.filter.TeamId == "" ? this.userDetail.TeamID : this.filter.TeamId;
        this.showLoader = true;
        var    Month= "", Happy= "", Ok= "", Sad= "", None= "";

        this._httpService.ajaxPost("Attendance/GetUserMoodReport", { "AttendanceId": 0, "UserId": UserId, "IsActive": this.filter.IsActive, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "siteId":this.filter.SiteId, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.userMoodItems = data["UserMood"];

//chart option 
var options = {
    chart: {
        renderTo: 'container',
        defaultSeriesType: 'column'
    },
    title: {
        text: 'Monthly Mood '+this.filter.MonthYear
    },
    xAxis: {
        categories: []
    },
    yAxis: {
        title: {
            text: 'In Percent (%)'
        }
    },
    series: []
};

//end chart options



//for highchart made by anuj
var Happyseries = {
                                name: 'Happy',
                                data: []
                            }; 
this.userMoodItems.forEach(element => {   
     options.xAxis.categories.push(element.Month);   

Happyseries.data.push(parseFloat(element.Happy));

                        }                        
                        );
options.series.push(Happyseries);    

//ok begins
var Okseries = {
                                name: 'Ok',
                                data: []
                            }; 
this.userMoodItems.forEach(element => {   
   

Okseries.data.push(parseFloat(element.Ok));

                        }                        
                        );
options.series.push(Okseries); 
//ok finish
//sad begin
var Sadseries = {
                                name: 'Sad',
                                data: []
                            }; 
this.userMoodItems.forEach(element => {   
    

Sadseries.data.push(parseFloat(element.Sad));

                        }                        
                        );
options.series.push(Sadseries); 
//sad end




// series.data.push(parseFloat(element.Ok));
// series.data.push(parseFloat(element.Sad));


//loop end here 

var Highcharts = require('highcharts');
var chart = new Highcharts.Chart(options);
require('highcharts/modules/exporting')(Highcharts);

//end high chart

            },
            err => {
                console.log("GetUserMoodReport Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
                           
            }
        );
    }

    ngAfterViewInit() {
        $(".datemonthYear").datetimepicker({
            format: 'YYYY',
            maxDate: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    BindFilters() {
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": userId }).subscribe(
            data => {
                this.teamItems = data["AssignedTeam"];
            },
            err => {
                console.log("BindFilters Failed");
                this.showLoader = false;
            },
            () => {
                this._httpService.ajaxPost('Users/GetUsers', {
                    "IsActive": 1,
                    "Team": this.userDetail.TeamID,
                    "UserId": userId
                }).subscribe(
                    data => {
                        this.siteUserItems = data["Users"];
                    },
                    err => {
                        console.log("BindFilters Failed");
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                        this.GetUserMood(true);
                    }
                    );
            }
        );
    }

   

    public clearFilter() {
        this.filter.UserId = this.userDetail.SiteUserId;
        this.filter.TeamId = '';
        this.filter.MonthYear = moment().format('YYYY');
        this.filter.SiteId = '';
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/UserMoodReport/userMoodReport.component.ts
 **/